module.exports = __webpack_public_path__ + "img/role04.8718add5.png";